import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Button from '@material-ui/core/Button'

import SimpleTable from 'components/table/SimpleTable'
import SimpleTableDeleteDialog from 'components/table/SimpleTableDeleteDialog'
import SimpleTableHeader from 'components/table/SimpleTableHeader'
import SimpleTableActions from 'components/table/SimpleTableActions'

import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import projectActions from 'store/modules/project'
import networkActions from 'store/modules/network'
import settings from 'settings'

const AddIcon = settings.icons.add
const EditIcon = settings.icons.edit
const DeleteIcon = settings.icons.delete
const ViewIcon = settings.icons.view

const useStyles = makeStyles(theme => ({
  
}))

const ProjectList = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [ deleteConfirmOpen, setDeleteConfirmOpen ] = useState(false)
  const [ deleteConfirmItem, setDeleteConfirmItem ] = useState(null)

  const projects = useSelector(selectors.project.collection.list)
  const activeProjectId = useSelector(selectors.user.activeProjectId)

  const onAdd = () => dispatch(routerActions.navigateTo('project.edit', { id: 'new' }))
  const onEdit = (id) => dispatch(routerActions.navigateTo('project.edit', { id }))
  const onDelete = (id) => dispatch(projectActions.delete(id))
  const onView = (id) => dispatch(projectActions.setActiveProject(id))

  const openDeleteDialog = (item) => {
    setDeleteConfirmOpen(true)
    setDeleteConfirmItem(item)
  }

  const closeDeleteDialog = () => {
    setDeleteConfirmOpen(false)
    setDeleteConfirmItem(null)
  }


  const fields =[{
    title: 'Name',
    name: 'name',
  }]

  const data = projects.map((project, index) => {
    return {
      id: project.id,
      name: project.name + (activeProjectId == project.id ? ' (*)' : ''),
    }
  })

  const addButton = (
    <Button 
      className={classes.button} 
      variant="contained"
      color="secondary"
      onClick={ onAdd }
    >
      Add 
      <AddIcon />
    </Button>
  )

  const actions = [{
    title: 'Delete',
    icon: DeleteIcon,
    handler: (item) => openDeleteDialog(item),
  }, {
    title: 'Edit',
    icon: EditIcon,
    handler: (item) => onEdit(item.id),
  }, {
    title: 'View',
    icon: ViewIcon,
    handler: (item) => onView(item.id),
  }]

  return (
    <div>
      <SimpleTableHeader
        title='Workspaces'
        getActions={ () => addButton }
      />
      <SimpleTable
        data={ data }
        fields={ fields }
        getActions={ (item) => (
          <SimpleTableActions
            item={ item }
            actions={ actions }
          />
        )}
      />
      <SimpleTableDeleteDialog
        open={ deleteConfirmOpen }
        title={ deleteConfirmItem ? `the ${deleteConfirmItem.name} workspace` : null }
        onCancel={ () => closeDeleteDialog() }
        onConfirm={ () => {
          closeDeleteDialog()
          onDelete(deleteConfirmItem.id)
        }}
      />
    </div>
  )
}

export default ProjectList

